import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Participant} from '../model/Participant';
import {AlertService} from '../alert/alert.service';
import 'rxjs/add/operator/map';
import {Constants} from '../model/Constants';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SpeakersService {

  constructor(private http: HttpClient,
              private alertServiceService: AlertService) { }

  getSpeakers(): Participant[] {
    return [
      {
        "id": 2,
        "firstName": "Dominique",
        "lastName": "Arlettaz",
        "affiliation": "Université de Lausanne"
      },
      {
        "id": 3,
        "firstName": "Tobias",
        "lastName": "Berger",
        "affiliation": "University of Sheffield"
      },
      {
        "id": 4,
        "firstName": "John",
        "lastName": "Coates",
        "affiliation": "University of Cambridge"
      },
      {
        "id": 5,
        "firstName": "Pierre",
        "lastName": "Colmez",
        "affiliation": "CNRS Paris"
      },
      {
        "id": 6,
        "firstName": "Andrzej",
        "lastName": "Dąbrowski",
        "affiliation": "Uniwersytet Szczeciński"
      },
      {
        "id": 7,
        "firstName": "Christopher",
        "lastName": "Deninger",
        "affiliation": "Universität Münster"
      },
      {
        "id": 8,
        "firstName": "Mladen",
        "lastName": "Dimitrov",
        "affiliation": "Université de Lille"
      },
      {
        "id": 9,
        "firstName": "Ivan",
        "lastName": "Fesenko",
        "affiliation": "University of Nottingham"
      },
      {
        "id": 10,
        "firstName": "Mahesh",
        "lastName": "Kakde",
        "affiliation": "King's College London"
      },
      {
        "id": 12,
        "firstName": "Krzysztof",
        "lastName": "Kłosin",
        "affiliation": "City University of New York"
      },
      {
        "id": 13,
        "firstName": "Piotr",
        "lastName": "Krasoń",
        "affiliation": "Uniwersytet Szczeciński"
      },
      {
        "id": 14,
        "firstName": "Stephen",
        "lastName": "Lichtenbaum",
        "affiliation": "Brown University"
      },
      {
        "id": 15,
        "firstName": "Preda",
        "lastName": "Mihailescu",
        "affiliation": "Georg-August-Universität Göttingen"
      },
      {
        "id": 16,
        "firstName": "Jan",
        "lastName": "Nekovár",
        "affiliation": "Université Pierre et Marie Curie"
      },
      {
        "id": 17,
        "firstName": "Wiesława",
        "lastName": "Nizioł",
        "affiliation": "CNRS, ÉNS-Lyon"
      },
      {
        "id": 18,
        "firstName": "Cristian",
        "lastName": "Popescu",
        "affiliation": "University of California, San Diego"
      },
      {
        "id": 19,
        "firstName": "Peter",
        "lastName": "Schneider",
        "affiliation": "Universität Münster"
      },
      {
        "id": 20,
        "firstName": "Romyar",
        "lastName": "Sharifi",
        "affiliation": "University of California, Los Angeles"
      },
      {
        "id": 21,
        "firstName": "Jacques",
        "lastName": "Tilouine",
        "affiliation": "Université Paris 13"
      },
      {
        "id": 22,
        "firstName": "Yoichi",
        "lastName": "Uetake",
        "affiliation": "UAM Poznań"
      },
      {
        "id": 23,
        "firstName": "Jean-Pierre",
        "lastName": "Wintenberger",
        "affiliation": "Université de Strasbourg"
      },
      {
        "id": 24,
        "firstName": "Sarah",
        "lastName": "Zerbes",
        "affiliation": "University College London"
      },
      {
        "id": 25,
        "firstName": "Andrzej",
        "lastName": "Schinzel",
        "affiliation": "Polish Academy of Sciences"
      },
      {
        "id": 26,
        "firstName": "Javier",
        "lastName": "Fresán",
        "affiliation": "École polytechnique"
      }
    ];
  }

  private handleError(error: any) {
    this.alertServiceService.error('An error occurred: ', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/service/speakers.service.ts